export enum SvcParameters {
  WorkCouncils = 'WORK_COUNCIL',
  SubtitleEnabled = 'SUBTITLE_ENABLE',
  VoiceToText = 'SPEECH_TO_TEST',
  BosShowTabActionPlan = 'INTEGRATION_BOS_ACP_REVAMP',
  BosFieldOriginatorModal = 'SOC_CUSTOM_OBSERVATOR_REVAMP',
  AlertShowTabActionPlan = 'INTEGRATION_ALR_ACP_REVAMP',
  UnsafeConditionShowTabActionPlan = 'INTEGRATION_UNC_ACP_REVAMP',
  UnsafeConditionShowTabPlanning = 'UNC_PLANNED_FOR_REVAMP',
  UnsafeConditionShowIntegrationCmms = 'UNC_CMMS_REVAMP',
  UnsafeConditionRevampResponsibleTeam = 'UNC_RESPONSIBLE_TEAM_REVAMP',
  UnsafeConditionRevampEquipment = 'UNC_EQUIPMENT_REVAMP',
  BosRevampResponsibleTeam = 'BOS-REVAMP-RESPONSIBLE-TEAM',
  EnableLoginMultiUsers = 'ENABLE_LOGIN_MULTI_USERS',
  CheckinEnabled = 'CHECKIN_ENABLE',
  DefectTagShowTabActionPlan = 'INTEGRATION_DFT_ACP_REVAMP',
  DefectTagShowTabPlanning = 'DFT_PLANNED_FOR_REVAMP',
  DefectTagRevampResponsibleTeam = 'DFT_RESPONSIBLE_TEAM_REVAMP',
  DefectTagShowIntegrationCmms = 'DFT_CMMS_REVAMP',
  /** Admin > Funcionalidades > "Mapa" — enables the map feature across the modules. AB#71830. */
  EnableMaps = 'ENABLE_MAPS',
  /**
   * Admin > Funcionalidades > CIL "Edição de inspeções concluídas - Revamp" — TRUE restricts editing
   * inspection questions to the CIL module administrator. AB#71835.
   */
  CilRestrictEditCompletedInspections = 'EDIT_INSPECTIONS_COMPLETED_REVAMP',
  /**
   * Admin > Funcionalidades > CIL "Restringe novo registro pai - Revamp" — TRUE restricts creating
   * and editing a parent record (CIL PLAN) to the CIL module administrator. AB#69738.
   */
  CilRestrictNewParentRecord = 'ADD_NEW_PARENT_RECORD_LIL_REVAMP',
}
